import React, { useEffect, useState } from 'react';
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import { NavLink } from 'react-router-dom';
import axiosInstance from '../axiosConfig';

const OurServices = () => {
    const [services, setServices] = useState([]);
    const [heading, setHeading] = useState("");

    jarallaxElement();

    useEffect(() => {
        jarallax(document.querySelectorAll('.jarallax'));
    }, [services]);

    useEffect(() => {
        // Fetch data from the API
        const fetchServices = async () => {
            try {
                const response = await axiosInstance.get('/slider/service');
                if (response.data.success) {
                    setHeading(response.data.slider.heading || "Our Services");
                    setServices(response.data.slider.link_slider_content || []);
                }
            } catch (error) {
                console.error("Error fetching services:", error);
            }
        };

        fetchServices();
    }, []);

    return (
        <section aria-label="section" className="no-top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <h2 className="wow fadeIn">{heading}</h2>
                        <div className="de-separator"></div>
                    </div>
                    {services.map((item, index) => (
                        <div 
                            className="col-lg-3 text-center jarallax" 
                            key={index} 
                            data-jarallax-element={-10 * (index + 1)} 
                        >
                            <div className="de-box-a">
                                <div className="d-image">
                                    <img src={item.image} alt={item.title} />
                                </div>
                                <div className="d-deco-1"></div>
                                <div className="d-deco-2"></div>
                            </div>
                            <div className="spacer-20"></div>
                            <h4>{item.title}</h4>
                        </div>
                    ))}
                </div>
                <div className="spacer-single"></div>
                <div className="text-center">
                    <NavLink to="/services" className="btn-main">All Services &amp; Prices</NavLink>
                </div>
            </div>
        </section>
    );
};

export default OurServices;
